angular.module('cian.ui.checklist', [])
	.config(["$interpolateProvider", function($interpolateProvider) {
		$interpolateProvider.startSymbol('{$');
		$interpolateProvider.endSymbol('$}');
	}]);

angular.module('cian.ui.checklist')
	.directive('checklist', function() {
		return {
			scope: {
				items: '=',
				source: '='
			},
			restrict: 'EA',
			template: [
				'<cian-ui-checkbox-wrapper ng-repeat="item in items track by item.value">',
				'  <input type="checkbox" ng-checked="isChecked(item)" ng-click="toggle(item)">',
				'  {$ item.text $}',
				'</cian-ui-checkbox-wrapper>'
			].join(''),
			link: function(scope, elem, attrs) {
				if (!scope.source.value) {
					scope.source.value = [];
				}

				scope.isChecked = function(itemToCheck) {
					var isChecked = false;
					for (var i = 0; i < scope.source.value.length; i++) {
						if (scope.source.value[i] === itemToCheck.value) {
							isChecked = true;
							break;
						}
					}
					return isChecked;
				};

				scope.toggle = function(item) {
					var idx = scope.source.value.indexOf(item.value);

					if (idx > -1) {
						scope.source.value.splice(idx, 1);
					} else {
						scope.source.value.push(item.value);
					}
				};
			}
		}
	});



//////////////////
// WEBPACK FOOTER
// ../components/ui/src/checklist/checklist.js
// module id = 904
// module chunks = 0